// es/messages.js
const messagesEs = {
  about: 'Acerca de',
  acceptanceCriteria: 'Criterios de Aceptación',
  accomplishments: 'Logros',
  actions: 'Acciones',
  activatePod: 'Activar Pod',
  activePods: 'Pods activos',
  activity: 'Actividad',
  add: 'Agregar',
  createHub:	"Crear Centro",
  createSolution:"Crear Solución",
  category:"Categoría",
comments:"Comentarios",
 talentexplorer: "Explorador de Talento",
 interviewrequests:"Solicitudes de Entrevista",
  addBlocker: 'Agregar Información de Bloqueo',
  addingCandidateWait: 'Añadiendo Candidato Espere...',
  addPortfolio: 'Agregar portafolio',
  addStakeholder: 'Agregar Stakeholder',
  addVideoUpdate: 'Agregar Actualización de Video',
  all: 'Todo',
  allReporters: 'Todos los reporteros',
  allRepoCheckins: 'Todos los check-ins del repositorio',
  approve: 'Aprobar',
  findAgents:"Encontrar agentes",
  approved: 'Aprobado',
  podTime: "Tiempo del POD",
  podVelocity: "Velocidad del POD",
 podBlockers: "Bloqueadores del POD",
 podsync:"Sincronización POD",
  approvalRequests: 'Solicitudes de aprobación',
  approvedPRCount: 'Número de PR aprobados',
  applyFilters: 'Aplicar Filtros',
  assignedItems: 'Elementos asignados',
  backToPods: 'Volver a Mis Pods',
  basicInformation: 'Información básica',
  blocker: 'Bloqueador',
  blockerDetails: 'Detalles del Bloqueo',
  blockers: 'bloqueadores',
  board: 'Tablero',
  browseTalent: 'Buscar talento',
  bugs: 'Bugs',
  calendlyUrl: 'URL Calendly',
  cancel: 'Cancelar',
  candidate: 'Candidato',
  candidates: 'Candidatos',
  categories: 'Categorías',
  certifications: 'Certificaciones',
  certificationUrl: 'URL de certificación',
  checkBoxBlocker: 'Marque esta casilla si es un bloqueador',
  ciCdPipeline: 'Pipeline CI/CD',
  clear: 'Limpiar',
  clickHereUploadVideoClip: 'Haga clic aquí para subir un clip de video !',
  client: 'Cliente',
  cloudCost: 'Costo en la Nube',
  code: 'Líneas de Código',
  codeSmells: 'Olores de código',
  companyName: 'Nombre de la empresa',
  copied: '¡Copiado!',
  copyright: 'Copyright © 2025-presente Brilli Global, Inc. Todos los derechos reservados.',
  copyToClipboard: 'Copiar al portapapeles',
  cost: 'Costo',
  costDetails: 'Detalles del costo',
  country: 'País',
  create: 'Crear',
  createArt: 'Crear ART',
  createGig: 'Crear proyecto',
  createPod: 'Crear POD',
  createProfile: 'Crear perfil',
  createProfileOpportunity: 'Crea tu perfil en nuestra base de talentos para ser incluido en diversas oportunidades de trabajo remoto.',
  createTask: 'Crear tarea',
  createYourOwnPod: 'Crea tu propio Pod y busca proyectos',
  creatingProfile: 'Creando perfil',
  currency: 'Moneda',
  currentWeek: 'Semana actual',
  dashboard: 'Tablero',
  date: 'Fecha',
  dateRangeFilter: 'Filtro de rango de fechas',
  deactivatePod: 'Desactivar Pod',
  deactivateToUpdate: '¡Desactive el pod para actualizar el pod!',
  defects: 'Defectos',
  delete: 'Eliminar',
  deletePod: 'Eliminar Pod',
  description: 'Descripción',
  detailsForGitHubRepo: 'Detalles del repositorio en GitHub',
  done: 'Hecho',
  Done: 'Completado',
  doraMetrics: 'Métricas Dora',
  dueDate: 'Fecha de vencimiento',
  duplicatedLinesDensity: 'Densidad de líneas duplicadas',
  edit: 'Editar',
  editPod: 'Edite su pod y navegue por proyectos',
  education: 'Educación',
  educationAndCertifications: 'Educación y Certificaciones',
  email: 'Correo Electrónico',
  endDate: 'Fecha de fin',
  enterEmailToInvite: 'Ingrese un correo electrónico para invitar',
  enterPodMission: 'Ingresar la misión del Pod',
  enterPodName: 'Ingresar el nombre del Pod',
  enterStoryDescription: 'Ingrese una Descripción de la Historia',
  executionDate: 'Fecha de ejecución',
  executionID: 'ID de ejecución',
  externalPod: 'Pod externo',
  fileNameNoSpaces: 'El nombre del archivo no debe incluir espacios entre todos los elementos o caracteres',
  fileUpload: 'Carga de archivos',
  findBestFreelancers: '¡Encuentra a los mejores freelancers o pods de talento para obtener la entrega de tus proyectos más rápido!',
  findBestPod: 'Encuentra grupos que coincidan con tu experiencia/conjunto de habilidades',
  findPods: 'Buscar PODs',
  findTalent: 'Encontrar talento',
  findYourBestTalentPod: 'Encuentra tu mejor POD de talento',
  firstName: 'Nombre',
  focus: 'Enfoque',
  getStarted: 'Empezar',
  gitHubRepo: 'Repositorio de GitHub',
  gitHubUsername: 'Nombre de usuario de GitHub',
  github: 'Github',
  githubSummary: 'Resumen de GitHub',
  githubUrl: 'URL de Github',
  githubUser: 'Usuario de GitHub',
  globalWorkPlatform: 'Plataforma de trabajo global',
  home: 'Inicio',
  inactivePod: 'Pod Inactivo',
  individual: 'Individual',
  industry: 'Industria',
  inProgress: 'En progreso',
  institute: 'Instituto',
  internalPod: 'Pod interno',
  invite: 'Invitar',
  invoices: 'Facturas',
  issueKey: 'Clave del problema',
  issueStatus: 'Estado del problema',
  issueSummary: 'Resumen del problema',
  jiraIssue: 'Problema de Jira',
  jiraIssues: 'Problemas Jira',
  jiraItem: 'Elemento Jira',
  jiraTimeDetails: 'Registro de Tiempo',
  jiraUsername: 'Nombre de usuario de Jira',
  joinPod: 'Unirse al Pod',
  keepDoing: 'Seguir haciendo',
  keyword: 'Palabra clave',
  languageSpoken: 'Idioma hablado',
  lastName: 'Apellido',
  latestSprintVelocity: 'Última Velocidad del Sprint',
  linkedIn: 'LinkedIn',
  linkedInUrl: 'URL de LinkedIn',
  linesOfCodeByDay: 'Líneas de código por día',
  listOfTalents: 'Lista de talentos',
  loading: 'Cargando',
  loadingAcceptanceCriteria: 'Cargando Criterios de Aceptación',
  loadingStoryDescription: 'Cargando Descripción de la Historia',
  loadingTestCases: 'Cargando Casos de Prueba',
  logOut: 'Cerrar Sesión',
  login: 'Iniciar sesión',
  manage: 'Gestionar',
  manageActivities: 'Gestiona tus actividades y actualizaciones diarias del Pod',
  manageProfile: 'Gestionar perfil',
  manageProfileHere: 'Administra tu perfil aquí',
  managePod: 'Gestionar Pod',
  managePods: 'Gestiona todos tus pods y sus actividades',
  markComplete: 'Marcar como completado',
  middleName: 'Segundo nombre',
  myPods: 'Mis Pods',
  myTasks: 'Mis tareas',
  name: 'Nombre',
  ncloc: 'Ncloc',
  newActivityUpdate: 'Nueva Actualización de Actividad',
  next: 'Siguiente',
  noArtOptionsAvailable: 'No hay opciones de ART disponibles',
  noBlockers: 'No hay bloqueadores',
  noCandidates: 'No hay candidatos añadidos',
  noCandidatesAddedToPod: '¡No hay candidatos añadidos al Pod!',
  noCandidateReviews: 'No hay revisiones de candidatos.',
  noData: 'Sin Datos',
  noDataAvailable: 'No hay datos disponibles',
  noExperience: 'Sin experiencia',
  noMatchingPods: 'No hay pods disponibles que coincidan',
  noNotifications: 'No hay notificaciones',
  noPodActivity: 'No tienes ninguna actividad de POD',
  noPods: 'No tienes ningún Pod',
  noPodTasks: 'No tienes ninguna tarea de Pod',
  noReviews: 'No hay revisiones',
  noStakeholders: 'No hay stakeholders para este pod',
  noSubscription: 'No tienes ningún plan de suscripción',
  noVideoAvailable: 'No hay video disponible',
  notifications: 'Notificaciones',
  notificationRecipient: 'Destinatario de la notificación',
  otherInformation: 'Otra información',
  pending: 'Pendiente',
  pendingPods: 'Pods pendientes',
  phoneNumber: 'Número de teléfono',
  pipelineExecutionDetails: 'Detalles de ejecución del pipeline',
  pipelineName: 'Nombre del pipeline',
  pipelineVersion: 'Versión del pipeline',
  pleaseEnterStoryDescription: 'Por favor, ingrese una descripción de la historia y haga clic en enviar',
  pod: 'Pod',
  podActivities: 'Actividades del Pod',
  podActivity: 'Actividad del Pod',
  podAnalytics: 'Análisis de POD',
  podAssist: 'Asistente de Pod',
  podAutomation: 'Automatización de POD',
  podBoard: 'Tablero del Pod',
  podCategories: 'Categorías de Pod',
  podDescription: 'Descripción del Pod',
  podExperience: 'Experiencia de Pod',
  podFeedback: 'Feedback de Pod',
  podMetrics: 'Métricas de Pod',
  podName: 'Nombre del Pod',
  podQuery: 'Consulta de POD',
  podRequests: 'SOLICITUDES DE POD',
  podRetro: 'Retro del Pod',
  podrate: 'Tasa de Reproducción',
  podSize: 'Tamaño del Pod',
  podTask: 'Tarea del Pod',
  podTasks: 'Tareas del Pod',
  podTaskDescription: 'Descripción de la tarea de Pod',
  podTaskDueDate: 'Fecha de vencimiento de la tarea de Pod',
  podTaskName: 'Nombre de la tarea de Pod',
  podTaskOwner: 'Propietario de la tarea de Pod',
  podTaskStatus: 'Estado de la tarea de Pod',
  podTechStack: 'Tech Stack del Pod',
  PodTeamMember: 'miembro del equipo del POD',
  podType: 'Tipo de Pod',
  portfolio: 'Portafolio',
  portfolioUrl: 'URL del portafolio',
  post: 'Publicar',
  postActivity: 'Publicar Actividad',
  postPodActivity: 'Publicar Actividad del Pod',
  postRequirement: 'Publicar Requisito',
  posting: 'Publicando...',
  postedDate: 'Fecha de publicación',
  postedRequirements: 'Tus Requisitos Publicados del Pod',
  positionName: 'Nombre del puesto',
  prCount: 'Conteo de PR',
  preferredWorkHours: 'Horas de trabajo preferidas',
  preferredWorkHoursMonthly: 'Horas de trabajo preferidas /mes',
  prev: 'Anterior',
  previousPods: 'Pods anteriores',
  previousWeek: 'Semana anterior',
  primarySkill: 'Habilidad principal',
  privacyPolicy: 'Política de privacidad',
  privatePods: 'Pods privados',
  prSummary: 'Resumen de PR',
  projectKey: 'Clave del proyecto',
  profileLink: 'Enlace del Perfil',
  profileVisibility: 'Visibilidad del Perfil',
  public: 'Público',
  qualification: 'Calificación',
  ratePerHour: 'Tarifa /hora',
  ratePerMonth: 'Tarifa /mes',
  recentSearches: 'Búsquedas recientes',
  region: 'Región',
  Register: 'Registrarse',
  resetPassword: 'Restablecer Contraseña',
  restricted: 'Restringido',
  retro: 'Retro',
  reviewAndRating: 'Revisión y Calificación',
  revisionSummary: 'Resumen de la revisión',
  revisionURL: 'URL de la revisión',
  resume: 'Currículum',
  resumeLink: 'Ver Currículum',
  rowsPerPage: 'Filas por página',
  save: 'Guardar',
  search: 'Buscar',
  searchProjects: 'Buscar proyectos',
  secondarySkill: 'Habilidad secundaria',
  select: 'Seleccionar',
  selectArtName: 'Seleccionar el nombre del ART',
  selectAUser: 'Seleccionar un usuario',
  selectFilter: 'Seleccionar filtro',
  selectItemsPerPage: 'Seleccionar elementos por página',
  selectJiraIssues: 'Seleccionar Problemas de Jira',
  selectPod: 'Seleccione un Pod',
  selectPodTeamMember: 'Seleccionar miembro del equipo del POD',
  selectPods: 'Seleccionar Pods',
  services: 'Servicios',
  setting: 'Configuración',
  shareableLink: 'Enlace Compartible',
  signUpToGetStarted: '¡"Regístrate" a continuación para comenzar!',
  skills: 'Habilidades',
  skillsAndExpertise: 'Habilidades y experiencia',
  sonarqubeprojectkey: 'Clave del Proyecto Sonarqube',
  sonarqubeStats: 'Estadísticas de Sonarqube',
  specialization: 'Especialización',
  sprintVelocity: 'Velocidad de sprint',
  sprint: 'Sprint',
  spotsLeft: 'Lugares Disponibles',
  startDate: 'Fecha de inicio',
  startDoing: 'Empezar a hacer',
  status: 'Estado',
  stopDoing: 'Dejar de hacer',
  storyDescription: 'Descripción de la Historia',
  stories: 'Historias',
  submit: 'Enviar',
  submittedDate: 'Fecha de envío',
  submittedPRCount: 'Número de PR enviados',
  subscription: 'Suscripción',
  talentApprovalRequests: 'Solicitudes de aprobación de talentos',
  talentCode: 'Código de talento',
  talent: 'Talento',
  taskForm: 'Formulario de tarea',
  taskManager: 'Administrador de tareas',
  taskName: 'Nombre de la tarea',
  tasks: 'Tareas',
  teamMember: 'Miembro del equipo',
  techStack: 'TechStack',
  termsOfService: 'Términos del servicio',
  testCases: 'Casos de Prueba',
  time: 'Tiempo',
  timeLog: 'Registro de tiempo',
  timeSubmit: 'Enviar Hora',
  timeZone: 'Zona horaria',
  
  toDo: 'Por hacer',
  todaysFocus: 'Enfoque del día',
  totalLinesChangedLastWeek: 'Total de líneas modificadas la semana pasada',
  totalLinesChangedThisWeek: 'Total de líneas modificadas esta semana',
  totalPRCount: 'Número total de PR',
  university: 'Universidad',
  update: 'Actualizar',
  updateProfileHere: 'Actualiza tu perfil aquí',
  updatingVisibility: 'Actualizando visibilidad...',
  upload: 'Subir',
  userStory: 'Historia de usuario',
  validFrom: 'Válido desde',
  validTill: 'Válido hasta',
  videoUrl: 'URL del video',
  view: 'Ver',
  viewActivities: 'Ver Actividades',
  viewActivity: 'Ver actividad',
  viewDetails: 'Ver detalles',
  viewPodActivities: 'Ver actividades del Pod',
  viewPodDetails: 'Ver detalles del Pod',
  viewProfile: 'Ver perfil',
  viewTasks: 'Ver tareas',
  viewTimeEntries: 'Ver entradas de tiempo',
  viewVideo: 'Ver video',
  visitFindTalent: "Por favor, visite la página 'Buscar talento' y agregue individuos talentosos a su pod.",
  vulnerabilities: 'Vulnerabilidades',
  welcome: '¡Bienvenido a Artemy.ai!',
  workExperience: 'Experiencia laboral',
  yourPod: 'Tu Pod',
  yourPods: 'Tus Pods',
  yourPostedPodActivity: 'Su actividad de Pod publicada',

  findTickets: 'Encontrar Tickets',
  epics: 'Épicas',
  podTasks: 'Tareas del Pod',
  date: 'Fecha',
  talent: 'Talento',
  focus: 'Enfoque',
  startDate: 'Fecha de inicio',
  endDate: 'Fecha de fin',
  status: 'Estado',
  allStatus: 'Todos los Estados',
  blocked: 'Bloqueado',
  onTrack: 'En Camino',
  activityDetails: 'Detalles de Actividad',
  jiraIssues: 'Problemas de Jira',
  todaysFocus: 'Enfoque del Día',
  accomplishments: 'Logros',
  blockers: 'Bloqueadores',
  videoUpdate: 'Actualización de Video',
  comments: 'Comentarios',
  addBlockerInformation: 'Agregar Información de Bloqueo',
  blockerDetails: 'Detalles del Bloqueo',
  cancel: 'Cancelar',
  saveChanges: 'Guardar Cambios',
  selectJiraIssues: 'Seleccionar Problemas de Jira',
  design: 'Diseño',
  development: 'Desarrollo',
  testing: 'Pruebas',
  bugFix: 'Corrección de Errores',
  documentation: 'Documentación',
  myPods: 'Mis Pods',
  postRetro: 'Publicar Retrospectiva',
  newRetro: 'Nueva Retrospectiva',
  startDoing: 'Empezar a Hacer',
  stopDoing: 'Dejar de Hacer',
  keepDoing: 'Seguir Haciendo',
  viewRetros: 'Ver Retrospectivas',
  podRetroFeedback: 'Retroalimentación del Pod',
  selectSprint: 'Seleccionar Sprint',
  thisTaskIsBlocker: 'Esta tarea es un bloqueador',
  category: 'Categoría',
  taskCreatedSuccessfully: '¡Tarea creada exitosamente!',
  taskManagement: 'Gestión de Tareas',
  searchJiraIssues: 'Buscar problemas en JIRA...',
  creatingTask: 'Creando Tarea...',
  createTask: 'Crear Tarea',
  description: 'Descripción',
  dueDate: 'Fecha de vencimiento',
  commentsHistory: 'Historial de Comentarios',
  noCommentsYet: 'Aún no hay comentarios',
  writeAComment: 'Escribir un comentario...',
  all: 'Todos',
  blockerStatus: 'Estado de Bloqueo',
  blockedTasks: 'Tareas Bloqueadas',
  unblockedTasks: 'Tareas Desbloqueadas',
  clearDateRange: 'Limpiar Rango de Fechas',
  selectDateRange: 'Seleccionar Rango de Fechas',
  showAllTime: 'Mostrar Todo el Tiempo',
  noTasksFound: 'No se encontraron tareas',
  noLinkedIssues: 'No hay problemas vinculados',
  timeSheet: 'Hoja de Tiempo',
  podTimeSheet: 'Hoja de Tiempo del Pod',
  userStory: 'Historia de Usuario',
  hours: 'Horas',
  minutes: 'Minutos',
  actions: 'Acciones',
  submitTimeEntries: 'Enviar Registros de Tiempo',
  selectCategory: 'Seleccionar Categoría',
  selectStory: 'Seleccionar Historia',
  addRow: 'Agregar Fila',
  podSelection: 'Selección de Pod',
  selectPodToView: 'Seleccione un pod para ver sprint y filtros de Talento',
  toDo: 'Por Hacer',
  podAssist: 'Asistente POD',
  inProgress: 'En Progreso',
  done: 'Completado',
  selectPodsRequired: 'Seleccionar Pods (Requerido)',
  enterStoryDescription: 'Ingresar Descripción de la Historia',
  podSyncSummaries: 'Resúmenes de Sincronización POD',
  enterMeetingUrl: 'Ingresar URL de reunión...',
  searchInSummaries: 'Buscar en resúmenes...',
  dateAndTime: 'Fecha y Hora',
  quickTimeRange: 'Rango de Tiempo Rápido',
    sortByDate: 'Ordenar por Fecha',
  selectTalents: 'Seleccionar Talentos',
  filterBySpecificCandidates: 'Filtrar por candidatos específicos (opcional)',
  talentSelection: 'Selección de Talento',
  priority: 'Prioridad',
  addComment: 'Agregar Comentario',
  taskDetails: 'Detalles de la Tarea',
  summary: 'Resumen',
  addMeeting: 'Agregar Reunión',
  
  podAutomation: 'Automatización de Pod',
  uploading: 'Subiendo...',
  uploadFile: 'Subir Archivo',
  send: 'Enviar',
  submitting: 'Enviando...',
  enterYourQuestionHere: 'Ingrese su pregunta aquí',
  submitTheResults: 'Enviar resultados',
  export: 'Exportar',
  podInsights: 'Información de Pod',
  askQuestionsAboutYourPod: 'Haga preguntas sobre las actividades de su pod, miembros del equipo y más',
  welcomeToPodInsights: '¡Bienvenido a Información de Pod!',
  startByAskingQuestionsLike: 'Comience preguntando cosas como',
  showAllPodActivitiesThatHadBlockers: 'Mostrar todas las actividades del pod que tuvieron bloqueadores',
  listAllCandidatesAndTheirPods: 'Listar todos los candidatos y sus pods',
  showStakeholdersFromIndia: 'Mostrar stakeholders de India',
  askAnythingAboutYourPods: 'Pregunte cualquier cosa sobre sus pods, miembros del equipo, actividades...',
  sending: 'Enviando...',
  analyzingYourQuestion: 'Analizando su pregunta...',
  pipelineCICD: 'Pipeline CI/CD',
  tickets: 'Tickets',
  metricName: 'Nombre de Métrica',
  metricValue: 'Valor de Métrica',
  commentsHistory: 'Historial de Comentarios',
  noCommentsYet: 'Aún no hay comentarios',
  writeAComment: 'Escribir un comentario...',
  solutionManagement: 'Gestión de Soluciones',
  searchSolutions: 'Buscar Soluciones...',
  refresh: 'Actualizar',
  createNewSolution: 'Crear Nueva Solución',
  solutionName: 'Nombre de Solución',
  solutionDescription: 'Descripción de Solución',
  updateSolution: 'Actualizar Solución',
  createSolution: 'Crear Solución',
  confirmSolutionDeletion: '¿Está seguro que desea eliminar la Solución?',
  artManagement: 'Gestión ART',
  podManagement: 'Gestión de Pods',
  searchPods: 'Buscar pods...',
  viewPod: 'verPod',
  searchARTs: 'Buscar ARTs...',
  noARTsFound: 'No se encontraron ARTs. Cree su primer ART haciendo clic en el botón "Crear nuevo ART".',
  createNewART: 'Crear Nuevo ART',
  selectGig: 'Seleccionar Proyecto',
  artName: 'Nombre ART',
  artDescription: 'Descripción ART',
  createART: 'Crear ART',
  confirmDeletion: 'Confirmar Eliminación',
  confirmARTDeletion: '¿Está seguro que desea eliminar el ART?',
  primaryLanguage: 'Idioma Principal',
  selectSkills: 'Seleccionar Habilidades',
  timeZone: 'Zona Horaria',
  updateART: 'Actualizar ART',
  somethingWentWrong: 'Algo salió mal',
  reloadPage: 'Recargar Página',
  privatePods: 'Pods Privados',
  activePods: 'Pods Activos',
  completedPods: 'Pods Completados',
  pendingPods: 'Pods Pendientes',
  loadingPods: 'Cargando pods...',
  retry: 'Reintentar',
  noPodsFound: 'No se encontraron pods',
  createFirstPod: 'Cree su primer pod para comenzar',
  previous: 'Anterior',
  showing: 'Mostrando',
  size: 'Tamaño',
  teamSize: 'Tamaño del Equipo',
  activeMembers: 'Miembros Activos',
  stakeholders: 'Stakeholders',
  podManagers: 'Administradores de Pod',
  addManager: 'Agregar Administrador',
  podManager: 'Administrador de Pod',
  noManagersAssignedYet: 'Aún no hay administradores asignados',
  addManagersToHelpOversee: 'Agregue administradores para ayudar a supervisar este pod',
  noStakeholdersYet: 'Aún no hay stakeholders',
  settings: 'Configuración',
  deletePod: 'Eliminar Pod',
  addPodManager: 'Agregar Administrador de Pod',
  selectManagerToInvite: 'Seleccione un administrador para invitar a este pod:',
  noManagersAvailableToInvite: 'No hay administradores disponibles para invitar.',
  selectAManager: 'Seleccionar un administrador',
  selectedManager: 'Administrador Seleccionado',
  inviteManager: 'Invitar Administrador',
  noTeamMembersYet: 'Aún no hay miembros del equipo',
  startByInvitingMembers: 'Comience invitando miembros a su pod',
  inviteTeamMembers: 'Invitar Miembros del Equipo',
  existingMembers: 'Miembros Existentes',
  inviteByEmail: 'Invitar por Correo',
  searchByNameOrSkills: 'Buscar por nombre o habilidades...',
  optionalSelectUserToNotify: 'Opcional: Seleccione un usuario para notificar vía Slack',
  pleaseSelectPodToEnableFields: 'Por favor seleccione un Pod para habilitar otros campos',
  selectedCandidates: 'Candidatos Seleccionados',
  selectCandidatesToInvite: 'Seleccione candidatos para invitar a este pod',
  availableCandidates: 'Candidatos Disponibles',
  inviteNewMembersByEmail: 'Invitar Nuevos Miembros por Correo',
  emailAddresses: 'Direcciones de Correo',
  enterEmailAddresses: 'Ingrese direcciones de correo (separadas por comas)',
  hidePodTeamMembers: 'Ocultar miembros de este pod en la sección Buscar Pods (Actualmente Visible)',
  technicalDetails: 'Detalles Técnicos',
  currentTeamSize: 'Tamaño actual del equipo',
  communicationDetails: 'Detalles de Comunicación',
  podReview: 'Revisión de Pod',
  rating: 'Calificación',
  writeReview: 'Escribir Reseña',
  shareYourExperience: 'Comparta su experiencia con este pod...',
  submitReview: 'Enviar Reseña',
  viewPod: 'Ver Pod',
  managePod: 'Gestionar Pod',
  editPod: 'Editar Pod',
  skillsAndExperience: 'Habilidades y Experiencia',
  reviews: 'Reseñas',
  documents: 'Documentos',
  otherInfo: 'Otra Información',
  noWorkExperienceDataAvailable: 'No hay datos de experiencia laboral disponibles',
  selectART: 'Seleccionar ART',
  selectAnART: 'Seleccionar un ART',
  jiraConfiguration: 'Configuración Jira',
  jiraProjectKey: 'Clave de Proyecto Jira',
  jiraURL: 'URL de Jira',
  jiraAdminEmail: 'Correo de Administrador Jira',
  jiraAdminAPIToken: 'Token API de Administrador Jira',
  jiraOpenStoryBugStatus: 'Estado de Historia/Error Abierto en Jira',
  jiraClosedStoryBugStatus: 'Estado de Historia/Error Cerrado en Jira',
  gitHubConfiguration: 'Configuración GitHub',
  gitHubUsername: 'Usuario GitHub',
  gitHubAPIToken: 'Token API GitHub',
  gitHubRepositoryName: 'Nombre de Repositorio GitHub',
  circleCIConfiguration: 'Configuración CircleCI',
  circleCIGitHubUsername: 'Usuario GitHub CircleCI',
  circleCIGitHubRepository: 'Repositorio GitHub CircleCI',
  circleCIAPIToken: 'Token API CircleCI',
  sonarQubeConfiguration: 'Configuración SonarQube',
  sonarQubeCloudURL: 'URL de SonarQube Cloud',
  sonarQubeAPIToken: 'Token API SonarQube',
  awsConfiguration: 'Configuración AWS',
  awsAccessKeyID: 'ID de Clave de Acceso AWS',
  awsSecretAccessKey: 'Clave Secreta de Acceso AWS',
  awsRegion: 'Región AWS',
  bitBucketConfiguration: 'Configuración BitBucket',
  bitBucketUsername: 'Usuario BitBucket',
  bitBucketAppPassword: 'Contraseña de App BitBucket',
  bitBucketWorkspace: 'Espacio de Trabajo BitBucket',
  openAIConfiguration: 'Configuración OpenAI',
  openAIToken: 'Token OpenAI',
  storyPointsCalculation: 'Cálculo de Puntos de Historia',
  uploadStoryPointsCalculationFile: 'Subir Archivo de Cálculo de Puntos de Historia',
  currentFile: 'Archivo actual',
  notifications: 'Notificaciones',
  markAllAsRead: 'Marcar todas como leídas',
  tryAgain: 'Intentar Nuevamente',
  noNotificationsToDisplay: 'No hay notificaciones para mostrar',
  viewAllNotifications: 'Ver Todas las Notificaciones',
  enterMultipleEmailsSeparatedByCommas: 'Ingrese múltiples correos separados por comas',
  addEmailAddressesToInvite: 'Agregue direcciones de correo para invitar nuevos miembros',
  emailInvitationGuidelines: 'Pautas de Invitación por Correo',
  inviteesWillReceiveInstructions: 'Los invitados recibirán instrucciones para unirse a este pod',
  theyWillNeedToCreateAccount: 'Necesitarán crear una cuenta si no tienen una ya',
  noCandidatesAvailable: 'No hay candidatos disponibles',
  sendEmailInvites: 'Enviar Invitaciones por Correo',
 
  processingDataAndGeneratingInsights: 'Procesando datos y generando información',
  retroHistory: 'Historial de Retrospectivas',
  filterByMember: 'Filtrar por Miembro',
  podProductivity: 'Productividad del Pod',
  totalTasks: 'Tareas Totales',
  completed: 'Completadas',
  clearFilters: 'Limpiar Filtros',
  totalActivities: 'Actividades Totales',
  pendingApproval: 'Pendiente de Aprobación',
  sortBy: 'Ordenar Por',
  editSolution: 'Editar Solución',
  cannotDeleteAssociatedWithARTs: 'No se puede eliminar - asociado con ARTs',
  editART: 'Editar ART',
  createdDate: 'Fecha de Creación',
  podDetails: 'Detalles del Pod',
  currentARTProject: 'ART/Proyecto Actual',
  artProject: 'ART/Proyecto',
  selectAvailability: 'Seleccionar Disponibilidad',
  selectSkill: 'Seleccionar Habilidad',
  selectTimezone: 'Seleccionar Zona Horaria',
  selectLocation: 'Seleccionar Ubicación',
  selectBudget: 'Seleccionar Presupuesto',
  podMember: 'Miembro del Pod',
  addToPod: 'Agregar al Pod',
  talentDetails: 'Detalles del Talento',
  reviewsFeedback: 'Reseñas y Comentarios',
  noEducationDataAvailable: 'No hay datos de educación disponibles',
  noCertificationDataAvailable: 'No hay datos de certificación disponibles',
  clientReview: 'Reseña del Cliente',
  noReviewsAvailableYet: 'Aún no hay reseñas disponibles',
  noClientReviews: 'Este talento no ha recibido reseñas de clientes hasta ahora',
  resumeAvailable: 'Currículum Disponible',
  viewDownloadResume: 'Ver o descargar el currículum del candidato',
  noResumeAvailable: 'No hay currículum disponible',
  noResumeUploaded: 'Este talento no ha subido un currículum.',
  codingAssessment: 'Evaluación de Código',
  assessmentAvailable: 'Evaluación Disponible',
  viewAssessmentResults: 'Ver los resultados de la evaluación de código del candidato',
  noAssessmentAvailable: 'No hay evaluación disponible',
  noAssessmentCompleted: 'Este talento no ha completado una evaluación de código.',
  partnerCompanyDetails: 'Detalles de la Empresa Asociada',
  companyIntroductionVideo: 'Video de Presentación de la Empresa',
  videoNotSupported: 'Su navegador no soporta la etiqueta de video.',
  location: 'Ubicación',
  noPodsMatchingCriteria: 'No se encontraron pods que coincidan con sus criterios',
  hirePod: 'Contratar Pod',
  notificationHistory: 'Historial de Notificaciones',
  filter: 'Filtrar',
  allNotifications: 'Todas las Notificaciones',
  markSelected: 'Marcar Seleccionadas',
  unread: 'No Leídas',
  noNotificationsFound: 'No se encontraron notificaciones',
  searchNotifications: 'Buscar notificaciones...',
  subscriptionManagement: 'Gestión de Suscripciones',
  choosePlanPrompt: 'Elige un plan que mejor se adapte a tus necesidades y escala conforme creces',
  cancelSubscription: 'Cancelar Suscripción',
  choosePlan: 'Elegir Plan',
  noPlansAvailable: 'No Hay Planes Disponibles',
  noPlansHelpText: 'Por favor, revisa más tarde o contacta con soporte para asistencia.',
  currentPlanDetails: 'Detalles del Plan Actual',
  renewalDate: 'Fecha de Renovación',
  subscriptionId: 'ID de Suscripción',
  paymentMethod: 'Método de Pago',
  cardHolder: 'Titular de la Tarjeta',
  expires: 'Expira',
  brand: 'Marca',
  billingHistory: 'Historial de Facturación',
  noInvoiceHistory: 'No hay historial de facturas disponible',
  needHelp: '¿Necesitas Ayuda?',
  supportText: 'Si tienes preguntas sobre nuestros planes de suscripción o necesitas asistencia, nuestro equipo de soporte está aquí para ayudarte.',
  contactSupport: 'Contactar Soporte',
  completeSubscription: 'Completa tu Suscripción',
  planDetails: 'Detalles del Plan',
  planName: 'Nombre del Plan',
  basePrice: 'Precio Base',
  numberOfUsers: 'Número de Usuarios',
  billingCycle: 'Ciclo de Facturación',
  orderSummary: 'Resumen del Pedido',
  annualDiscount: 'Descuento Anual',
  billingPeriod: 'Período de Facturación',
  tax: 'Impuesto',
  totalWithTax: 'Total con Impuestos',
  annually: 'anualmente',
  continue: 'Continuar',
  subscriptionSuccessful: '¡Suscripción Exitosa!',
  thankYouSubscribing: 'Gracias por suscribirte a',
  subscriptionActivated: 'Tu suscripción ha sido activada exitosamente.',
  goToDashboard: 'Ir al Panel',
  addPaymentMethod: 'Agregar Método de Pago',
  cardNumber: 'Número de Tarjeta',
  cardholderName: 'Nombre del Titular',
  expiryMonth: 'Mes de Expiración',
  expiryYear: 'Año de Expiración',
  postalCode: 'Código Postal',
  addCard: 'Agregar Tarjeta',
  getCountIsseswithNoCritria: 'Obtener recuento de problemas sin criterios de aceptación',
  paymentChoice: 'Usar Tarjeta Existente o Agregar Nueva Tarjeta',
  existingCardText: 'Ya tienes una tarjeta existente que termina en',
  useExistingCardPrompt: '¿Te gustaría usarla para esta suscripción?',
  useExistingCard: 'Usar Tarjeta Existente',
  addNewCard: 'Agregar Nueva Tarjeta',
  processing: 'Procesando...',
  subscriptionSuccessDetails: '¡fue exitosa!',
  accessAllFeatures: 'Ahora puedes acceder a todas las características incluidas en tu plan de suscripción.',
  editCardDetails: 'Editar Detalles de la Tarjeta',
  managerInvite: 'Invitación de Gerente',
  talentInvite: 'Invitación de Talento',
  invitePodManagers: 'Ingresa E-Mail para Invitar Gerentes de Pod',
  enterEmail: 'Ingresa E-Mail',
  invite: 'Invitar',
  yourInvoices: 'Tus Facturas',
  noInvoices: 'No tienes facturas.',
  amountDue: 'Monto Adeudado',
  amountPaid: 'Monto Pagado',
  noActiveSubscription: 'No tienes un plan de suscripción activo. Por favor haz clic en el enlace "Suscribirse" para agregar una suscripción.',
   noActiveSubscriptionStart: 'No tienes un plan de suscripción activo. Por favor haz clic en el',
  subscribe: 'Suscribirse',
  noActiveSubscriptionEnd: 'enlace para agregar una suscripción.'
};

export default messagesEs;
